/**
 * "More" nav dropdown (UserHeader + AuthHeader).
 * Icons: `public/images/more_menu_*.svg` — add your assets to match each row.
 */
import "./VipInstitutionalSubnav/vip-institutional-subnav.css";

export const MORE_SUBMENU_ITEMS = [
  {
    id: "vip_institutional",
    title: "VIP & Institutional",
    desc: "Your trusted digital asset platform for VIPs and institutions",
    to: "/vip-services",
    iconSrcDark: "/images/vip-menu-icon.svg",
    iconSrcLight: "/images/vip-menu-icon_light.svg",
  },
  {
    id: "announcements",
    title: "Announcements",
    desc: "Stay updated with latest platform news",
    to: "/announcement",
    iconSrcDark: "/images/announcements-icon.svg",
    iconSrcLight: "/images/announcements-icon_light.svg",
  },
  {
    id: "referral",
    title: "Referral",
    desc: "Invite friends and earn rewards",
    to: "/referral",
    iconSrcDark: "/images/p2p_icon_menu.svg",
    iconSrcLight: "/images/p2p_icon_menu_light.svg",
  },
  {
    id: "otc_trade",
    title: "OTC Trade",
    desc: "Crypto and fiat OTC at an admin-set price",
    to: "/otc-trade",
    iconSrcDark: "/images/otcdesk_icon_menu2.svg",
    iconSrcLight: "/images/otcdesk_icon_menu2_light.svg",
  },
  // {
  //   id: "proof_reserves",
  //   title: "Proof of Reserves",
  //   desc: "Transparent verification of user funds",
  //   to: "/proof-of-reserves",
  //   iconSrcDark: "/images/proof-menu-icon.svg",
  //   iconSrcLight: "/images/proof-menu-icon_light.svg",
  // },
  {
    id: "help_center",
    title: "Help Center",
    desc: "Get support and find answers quickly",
    to: "/help_center",
    iconSrcDark: "/images/helpmenu-icon.svg",
    iconSrcLight: "/images/helpmenu-icon_light.svg",
  },
  {
    id: "blogs",
    title: "Blogs",
    desc: "Learn crypto insights and updates",
    to: "/blogs",
    iconSrcDark: "/images/blogmenu-icon.svg",
    iconSrcLight: "/images/blogmenu-icon_light.svg",
  },
  // {
  //   id: "partners",
  //   title: "Partners",
  //   desc: "Explore our trusted global partners",
  //   to: "/coming_soon",
  //   iconSrcDark: "/images/partnermenu.svg",
  //   iconSrcLight: "/images/partnermenu_light.svg",
  // },
];
